import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './klentyAuthenticationView.module.scss';
import dateformat from 'dateformat';
import { Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { localizedStrings } from 'src/localization/index.jsx';
import Toast from 'src/components/toast';
import _ from 'lodash';
class KlentyAuthenticationView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      isCompanyApiKey: true,
      apikey: "",
      userName: "",
      errors: {}
    }

    this.handleUserAPISelection = this.handleUserAPISelection.bind(this);
    this.handleAccountSelected = this.handleAccountSelected.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleAuthenticationClick = this._handleAuthenticationClick.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedKlenty = localizedStrings.components.integrations.klenty;
  }

  componentDidMount() {
    if(this.props.integration) {
      this.populateState(this.props.integration)
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!this.props.integration && nextProps.integration) {
      this.populateState(nextProps.integration)
    }
  }

  populateState(integration) {
    this.setState({
      isCompanyApiKey: integration.configuration.companyApiKey,
      userName: integration.configuration.userName,
      apikey: ""
    })
  }

  handleUserAPISelection() {
    this.setState({
      isCompanyApiKey: false
    })
  }

  handleAccountSelected() {
    this.setState({
      isCompanyApiKey: true
    })
  }

  _handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
      errors: {}
    });
  }

  validateForm() {
    let errors = {};
    const { isCompanyApiKey, apikey, userName } = this.state;
    if (!apikey || apikey.trim() == '') {
      errors.apikey = this.localizedKlenty.error_messages.api_key;
    }

    const emailError = this._validateEmail(userName);
    if (emailError) {
      errors.userName = emailError;
    }

    return errors;
  }

  _validateEmail(email) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


    if (!email || email.trim() == '') {
      return this.localizedKlenty.error_messages.username;
    }

    if (!regex.test(email)) {
      return this.localizedKlenty.error_messages.username;
    }
  }

  hasFieldError(field) {
    return this.state.errors[field];
  }

  _handleAuthenticationClick() {
    const errors = this.validateForm();
    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors
      });

      return;
    }

    var userName = this.state.userName;

    this.props.authenticateAccount(this.state.apikey, userName, this.state.isCompanyApiKey).then((() => {
      if (!this.props.activating && _.isEmpty(this.props.error)) {
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.klenty}            
          /> , {
            autoClose: 3000,
        })
        this.props.trackAdoptionMetricsForPluginConnectedEvent('Klenty')
      }  
    }));
  }

  render() {
    return (
      <div className={styles.content}>
        <h1>{ this.localizedKlenty.activate.title }</h1>
        <p className={styles.summary}>{ this.localizedKlenty.activate.sub_text }</p>

        <Row className={styles.entities}>
          <Col sm={3} className={styles.field}>
            <h5>{ this.localizedKlenty.activate.username }</h5>
          </Col>
          <Col sm={6}>
            <div className={cx(styles.inputField)}>
              <input
                ref='userName'
                type="email"
                value={this.state.userName}
                placeholder={this.localizedKlenty.activate.placeholder.username}
                onChange={this._handleChange.bind(this, "userName")}
              />

              {this.state.errors.userName &&
                <span className={styles.errorMessage}>
                  <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                  {this.state.errors.userName}
                </span>
              }  
            </div>
          </Col>
        </Row>

        <Row className={styles.entities}>
          <Col md={12} className={styles.options}>
            <div className={styles.customField}>
              <i className={cx('fa', this.state.isCompanyApiKey ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle')} aria-hidden="true" onClick={this.handleAccountSelected}></i>
              <h5 >{this.localizedKlenty.activate.company_api_key.title}</h5>
              <p>{this.localizedKlenty.activate.company_api_key.sub_text}</p>
            </div>
          </Col>
        </Row>

        <Row className={cx(styles.entities, styles.companyApi)}>
          <Col sm={3} className={styles.field}>
            <h5>{this.localizedKlenty.activate.company_api_key.title}</h5>
          </Col>
          <Col sm={6}>
            <div className={cx(styles.inputField)}>
              <input
                ref='apikey-account'
                type="password"
                value={this.state.isCompanyApiKey ? this.state.apikey : ""}
                placeholder={this._setCompanyAPIPlaceholder()}
                disabled={!this.state.isCompanyApiKey}
                onChange={this._handleChange.bind(this, "apikey")}
              />
              {this.state.isCompanyApiKey && this.state.errors.apikey &&
                <span className={styles.errorMessage}>
                  <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                  {this.state.errors.apikey}
                </span>
              }  
            </div>
          </Col>
        </Row>

        <Row className={styles.entities}>
          <Col md={12} className={styles.options}>
            <div className={styles.customField}>
              <i className={cx('fa', !this.state.isCompanyApiKey ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle')} aria-hidden="true" onClick={this.handleUserAPISelection}></i>
              <h5 >{this.localizedKlenty.activate.user_api_key.title}</h5>
              <p>{this.localizedKlenty.activate.user_api_key.sub_text}</p>
            </div>
          </Col>
        </Row>

        <Row className={styles.entities}>
          <Col sm={3} className={styles.field}>
            <h5>{this.localizedKlenty.activate.user_api_key.title}</h5>
          </Col>
          <Col sm={6}>
            <div className={cx(styles.inputField)}>
              <input
                ref='apikey-user'
                type="password"
                value={!this.state.isCompanyApiKey ? this.state.apikey : ''}
                placeholder={this._setUserAPIPlaceholder()}
                disabled={this.state.isCompanyApiKey}
                onChange={this._handleChange.bind(this, "apikey")}
              />

              {!this.state.isCompanyApiKey && this.state.errors.apikey &&
                <span className={styles.errorMessage}>
                  <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                  {this.state.errors.apikey}
                </span>
              }  
            </div>
          </Col>
        </Row>
        
        <button className={styles.button} onClick={this._handleAuthenticationClick} disabled={this.props.activating}>
          {this.props.activating &&
            `${this.localizedCommons.actions.saving_changes}...`
          }

          {!this.props.activating &&
            this.localizedCommons.actions.save
          }
        </button>
      </div>
    );
  }

  _setCompanyAPIPlaceholder() {
    if (this.props.integration && this.props.integration.configuration.companyApiKey && this.state.isCompanyApiKey) {
      return `*************** ${this.localizedCommons.last_updated}: ${dateformat(this.props.integration.createdDate, 'dd mmm yyyy')}`;
    } else {
      return this.localizedKlenty.activate.enter_api_key;
    }
  }

  _setUserAPIPlaceholder() {
    if (this.props.integration && !this.props.integration.configuration.companyApiKey && !this.state.isCompanyApiKey) {
      return `*************** ${this.localizedCommons.last_updated}: ${dateformat(this.props.integration.createdDate, 'dd mmm yyyy')}`;
    } else {
      return this.localizedKlenty.activate.enter_api_key;
    }
  }
}

export default KlentyAuthenticationView;